import React from 'react';
import {Slider} from "antd";
import FieldError from "./FieldError";

class SASlider extends React.Component {

  render() {
    const {className, value, onChange, max, min, step, error, ...attributes} = this.props;
    const errorClassName = error ? " error":'';

    return (
      <span className={errorClassName + " " + className}>
        <Slider value={value}
                onChange={onChange}
                min={min}
                max={max}
                step={step}
                {...attributes}/>
        <br/>
        {error && (
          <FieldError error={error}/>
        )}
      </span>
    )
  }
}

export default SASlider;
